import { IStrategy } from "../../../types";
import FeatureCard from "./feature-card";

const profitColor = "#068939";
const lossColor = "rgb(183, 20, 20)";
const otherColor = "rgba(0,0,0,0.5)";

export const twoDecimalPoints = (num: number) => {
  return isFinite(num) ? Math.round((num + Number.EPSILON) * 100) / 100 : num;
};

const displayFeatureValue = (left: string, right: string, color: string) => {
  return (
    <FeatureCard title={left} content={right} color={color} />
  );
};

export const displayBreakEven = (strategy: IStrategy) => {
  const {
    putBreakEven,
    putBreakEvenPercentage,
    callBreakEven,
    callBreakEvenPercentage,
  } = strategy;
  if (callBreakEven && putBreakEven) {
    return (
      <>
        {displayFeatureValue(
          "Call Breakeven",
          `${twoDecimalPoints(callBreakEven)}, ${twoDecimalPoints(
            callBreakEvenPercentage || 0
          )}%`,
          otherColor
        )}

        {displayFeatureValue(
          "Put Breakeven",
          `${twoDecimalPoints(putBreakEven)}, ${twoDecimalPoints(
            putBreakEvenPercentage || 0
          )}%`,
          otherColor
        )}
      </>
    );
  } else if (callBreakEven) {
    return displayFeatureValue(
      "Breakeven",
      `${twoDecimalPoints(callBreakEven)}, ${twoDecimalPoints(
        callBreakEvenPercentage || 0
      )}%`,
      otherColor
    );
  } else if (putBreakEven) {
    return displayFeatureValue(
      "Breakeven",
      `${twoDecimalPoints(putBreakEven)}, ${twoDecimalPoints(
        putBreakEvenPercentage || 0
      )}%`,
      otherColor
    );
  }
};

export const displayFeatures = (data: IStrategy) => {
  const {
    maxLoss,
    maxLossROI,
    approxMargin,
    maxProfit,
    maxProfitROI,
    riskRewardRatio,
  } = data;
  return (
    <>
      <div
        style={{
          maxWidth: "100%",
        }}
      >
        {displayFeatureValue(
          "Max Profit",
          isFinite(maxProfit)
            ? `${twoDecimalPoints(maxProfit)}, (${twoDecimalPoints(
                maxProfitROI
              )}%)`
            : "Unlimited",
          profitColor
        )}
        {displayFeatureValue(
          "Max Risk",
          isFinite(maxLoss)
            ? `${twoDecimalPoints(maxLoss)}, (${twoDecimalPoints(
                maxLossROI
              )}%)`
            : "UNLIMITED",
          lossColor
        )}

        {displayFeatureValue(
          "Aprox Cost",
          `${twoDecimalPoints(approxMargin)}`,
          otherColor
        )}

        {displayBreakEven(data)}
        {isFinite(data.maxLossROI) &&
          displayFeatureValue(
            "RR Ratio",
            `1 : ${twoDecimalPoints(riskRewardRatio)}`,
            otherColor
          )}
      </div>
    </>
  );
};
